var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-title',[_vm._v(" "+_vm._s(_vm.$tc("dashboard.averageProcessingTimeHeading"))+" ")]),_c('v-card-text',[_c('BarChart',{attrs:{"chart-data":_vm.averageProcessingTimeData,"options":_vm.chartJSOptions,"styles":{
              height: "80vh"
            }}})],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }